import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import * as Global from '../Models/constants';
import { PowerBiEmbedConfig } from '../Models/common.model';

@Injectable({
    providedIn: 'root'
})
export class PowerBiReportsService {
    constructor(private http: HttpClient) {
    }

    private get embedConfigUrl(): string {
        const currentPath = window.location.pathname.replace(/\/$/, '');
        return `${currentPath}/getembedconfigjson`;
    }

    getEmbedConfig(): Observable<PowerBiEmbedConfig> {
        Global.AddLogs('Power BI Reports getEmbedConfig service method and API Url: ' + this.embedConfigUrl);

        return this.http.get<PowerBiEmbedConfig>(this.embedConfigUrl, {
            withCredentials: true
        })
            .pipe(
                retry(1),
                catchError(this.handleError)
            );
    }

    private handleError(error: any) {
        let errorMessage = '';
        if (error.error instanceof ErrorEvent) {
            errorMessage = error.error.message;
        } else {
            errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
        }

        console.log(errorMessage);
        return throwError(errorMessage);
    }
}
